import type { SVGProps } from 'react'

export interface IconProps extends SVGProps<SVGSVGElement> {
  width?: number
  height?: number
}

export const FireIcon = ({ width = 24, height = 24, ...props }: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.963 2.286C12.9027 2.20524 12.8268 2.13746 12.7397 2.08669C12.6527 2.03592 12.5563 2.00321 12.4564 1.99052C12.3564 1.97782 12.2549 1.9854 12.1579 2.01281C12.061 2.04021 11.9705 2.08687 11.892 2.15C9.9753 3.68882 8.71115 5.89528 8.35297 8.327C7.69599 7.8501 7.12026 7.27031 6.64797 6.61C6.5838 6.52031 6.50064 6.44586 6.40441 6.39198C6.30818 6.3381 6.20126 6.3061 6.09125 6.29827C5.98124 6.29044 5.87085 6.30697 5.76796 6.34668C5.66507 6.38639 5.5722 6.4483 5.49597 6.528C4.17514 7.90943 3.32837 9.67547 3.07833 11.5703C2.8283 13.4652 3.18797 15.3904 4.10526 17.0672C5.02255 18.7439 6.44982 20.0851 8.18031 20.8965C9.91081 21.7079 11.8547 21.9473 13.7303 21.58C15.606 21.2128 17.316 20.2579 18.6127 18.8538C19.9094 17.4498 20.7255 15.6693 20.9427 13.7704C21.1599 11.8715 20.7669 9.95282 19.8207 8.29219C18.8745 6.63157 17.4243 5.31528 15.68 4.534C14.6077 4.01257 13.676 3.2417 12.963 2.286ZM15.75 14.25C15.7496 14.7924 15.6316 15.3283 15.404 15.8207C15.1764 16.3131 14.8447 16.7502 14.4318 17.102C14.0189 17.4538 13.5346 17.7118 13.0123 17.8582C12.49 18.0046 11.9422 18.036 11.4066 17.9502C10.871 17.8643 10.3604 17.6633 9.90999 17.361C9.45962 17.0587 9.08018 16.6623 8.79788 16.1991C8.51557 15.7359 8.33711 15.217 8.2748 14.6782C8.21249 14.1393 8.26782 13.5934 8.43698 13.078C9.06498 13.543 9.78697 13.888 10.57 14.078C10.7825 12.7093 11.4627 11.4566 12.495 10.533C13.3958 10.653 14.2224 11.096 14.8211 11.7797C15.4199 12.4634 15.7499 13.3412 15.75 14.25Z"
      stroke="#181D29"
      strokeWidth="2"
    />
  </svg>
)

export const RoofIcon = ({ width = 24, height = 24, ...props }: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 41 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.33203 17.8333L18.3987 6.53333C18.9725 6.10301 19.2594 5.88785 19.5744 5.80491C19.8525 5.7317 20.1449 5.7317 20.423 5.80491C20.7381 5.88785 21.0249 6.10301 21.5987 6.53333L36.6654 17.8333M6.66537 15.3333V31.6667C6.66537 33.5335 6.66537 34.4669 7.02868 35.18C7.34826 35.8072 7.8582 36.3171 8.4854 36.6367C9.19844 37 10.1319 37 11.9987 37H27.9987C29.8655 37 30.799 37 31.512 36.6367C32.1392 36.3171 32.6491 35.8072 32.9687 35.18C33.332 34.4669 33.332 33.5335 33.332 31.6667V15.3333L23.1987 7.73333C22.0512 6.87269 21.4774 6.44236 20.8473 6.27648C20.291 6.13006 19.7064 6.13006 19.1501 6.27648C18.52 6.44236 17.9462 6.87269 16.7987 7.73333L6.66537 15.3333Z"
      stroke="#E1E1E4"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66537 15.3333L16.7987 7.73333C17.9462 6.87269 18.52 6.44236 19.1501 6.27648C19.7064 6.13006 20.291 6.13006 20.8473 6.27648C21.4774 6.44236 22.0512 6.87269 23.1987 7.73333L33.332 15.3333M3.33203 17.8333L18.3987 6.53333C18.9725 6.10301 19.2593 5.88785 19.5744 5.80491C19.8525 5.7317 20.1449 5.7317 20.423 5.80491C20.7381 5.88785 21.0249 6.10301 21.5987 6.53333L36.6654 17.8333"
      stroke="#181D29"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 35.75V24.4444C15 23.5888 15 23.161 15.1817 22.8342C15.3414 22.5467 15.5964 22.313 15.91 22.1665C16.2665 22 16.7332 22 17.6667 22H22.3333C23.2668 22 23.7335 22 24.09 22.1665C24.4036 22.313 24.6586 22.5467 24.8183 22.8342C25 23.161 25 23.5888 25 24.4444V35.75"
      stroke="#E1E1E4"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30.3872 4.92461C30.4273 4.13984 31.0829 3.48426 31.8677 3.4441C32.6923 3.40197 33.3432 4.0531 33.3012 4.87765L33.2432 5.99493L37.6095 1.57483L37.6115 1.57275C38.1648 1.01945 39.0896 0.920026 39.6728 1.50301C40.2555 2.08576 40.1567 3.00937 39.6044 3.56287H39.6058L35.2223 7.99886L36.3644 7.94086C37.189 7.89872 37.84 8.54983 37.798 9.37441C37.7579 10.1592 37.1023 10.8148 36.3175 10.8549L31.579 11.0966C30.7544 11.1387 30.1034 10.4877 30.1455 9.66305L30.3872 4.92461Z"
      fill="#181D29"
      stroke="#FAFAFB"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const WallsIcon = ({ width = 24, height = 24, ...props }: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.66537 29.6667V13.3333L16.7987 5.73333C17.9462 4.87269 18.52 4.44236 19.1501 4.27648C19.7064 4.13006 20.291 4.13006 20.8473 4.27648C21.4774 4.44236 22.0512 4.87269 23.1987 5.73333L33.332 13.3333V29.6667M3.33203 15.8333L18.3987 4.53333C18.9725 4.10301 19.2593 3.88785 19.5744 3.80491C19.8525 3.7317 20.1449 3.7317 20.423 3.80491C20.7381 3.88785 21.0249 4.10301 21.5987 4.53333L36.6654 15.8333"
      stroke="#E1E1E4"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M10 35L30 35" stroke="#E1E1E4" strokeWidth="2" strokeLinecap="round" />
    <path
      d="M6.66797 15.332V31.662M33.3346 15.332V31.662"
      stroke="#181D29"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.6006 28.4492C26.0173 28.9758 25.0901 28.9757 24.5068 28.4492C23.894 27.8959 23.8941 26.9752 24.5068 26.4219L25.3467 25.6641L18.0068 25.6641C17.2243 25.6641 16.5001 25.0805 16.5 24.2559C16.5 23.4311 17.2243 22.8477 18.0068 22.8477L25.3467 22.8477L24.5068 22.0898C23.894 21.5366 23.894 20.6158 24.5068 20.0625C25.0901 19.5359 26.0173 19.5359 26.6006 20.0625L30.1221 23.2422C30.735 23.7955 30.735 24.7162 30.1221 25.2695L26.6006 28.4492Z"
      fill="#181D29"
      stroke="#FAFAFB"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const WindowsIcon = ({ width = 24, height = 24, ...props }: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.9256 5.5378L16.9256 26.4598M4 15.9988H28M4 7.98435L4 24.0132C4 25.8319 4 26.7413 4.37512 27.3716C4.70404 27.9243 5.2216 28.3394 5.83245 28.5406C6.52913 28.7701 7.41683 28.5728 9.19223 28.1783L24.6589 24.7413C25.8511 24.4763 26.4471 24.3439 26.8921 24.0233C27.2846 23.7406 27.5927 23.3564 27.7836 22.9119C28 22.4081 28 21.7974 28 20.5762V11.4214C28 10.2001 28 9.58952 27.7836 9.08563C27.5927 8.64118 27.2846 8.25701 26.8921 7.97427C26.4471 7.65371 25.8511 7.52125 24.6589 7.25632L9.19224 3.81929C7.41683 3.42475 6.52913 3.22748 5.83246 3.45694C5.2216 3.65813 4.70404 4.07331 4.37512 4.62597C4 5.25628 4 6.16563 4 7.98435Z"
      stroke="#181D29"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const BasementIcon = ({ width = 24, height = 24, ...props }: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_10480_32531)">
      <path
        d="M5 17.6077C5 16.6504 5 16.1718 5.12338 15.731C5.23267 15.3406 5.41228 14.9733 5.65338 14.6474C5.92556 14.2794 6.30337 13.9855 7.05898 13.3978L18.3628 4.60593C18.9484 4.15051 19.2411 3.9228 19.5644 3.83527C19.8497 3.75804 20.1503 3.75804 20.4356 3.83527C20.7589 3.9228 21.0516 4.15051 21.6372 4.60593L32.941 13.3978C33.6966 13.9855 34.0744 14.2794 34.3466 14.6474C34.5877 14.9733 34.7673 15.3406 34.8766 15.731C35 16.1718 35 16.6504 35 17.6077V29.6659C35 31.5327 35 32.4662 34.6367 33.1792C34.3171 33.8064 33.8072 34.3164 33.18 34.6359C32.4669 34.9992 31.5335 34.9992 29.6667 34.9992H10.3333C8.46649 34.9992 7.53307 34.9992 6.82003 34.6359C6.19282 34.3164 5.68289 33.8064 5.36331 33.1792C5 32.4662 5 31.5328 5 29.6659V17.6077Z"
        stroke="#E1E1E4"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M10 20L30 20" stroke="#181D29" strokeWidth="2" strokeLinecap="round" />
      <path
        d="M7 25H9.5V27.8125H12.5V30.625H16V33"
        stroke="#181D29"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M29.7314 23.6445C30.3147 23.118 31.2419 23.118 31.8252 23.6445C32.4381 24.1978 32.4379 25.1185 31.8252 25.6719L30.9854 26.4297H38.3252C39.1077 26.4297 39.8319 27.0132 39.832 27.8379C39.832 28.6626 39.1078 29.2461 38.3252 29.2461H30.9854L31.8252 30.0039C32.4381 30.5572 32.438 31.4779 31.8252 32.0312C31.2419 32.5579 30.3148 32.5579 29.7314 32.0312L26.21 28.8516C25.597 28.2982 25.597 27.3775 26.21 26.8242L29.7314 23.6445Z"
        fill="#181D29"
        stroke="#FAFAFB"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_10480_32531">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const BasementStairwayIcon = ({ width = 24, height = 24, ...props }: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_10480_32498)">
      <path
        d="M5 17.6077C5 16.6504 5 16.1718 5.12338 15.731C5.23267 15.3406 5.41228 14.9733 5.65338 14.6474C5.92556 14.2794 6.30337 13.9855 7.05898 13.3978L18.3628 4.60593C18.9484 4.15051 19.2411 3.9228 19.5644 3.83527C19.8497 3.75804 20.1503 3.75804 20.4356 3.83527C20.7589 3.9228 21.0516 4.15051 21.6372 4.60593L32.941 13.3978C33.6966 13.9855 34.0744 14.2794 34.3466 14.6474C34.5877 14.9733 34.7673 15.3406 34.8766 15.731C35 16.1718 35 16.6504 35 17.6077V29.6659C35 31.5327 35 32.4662 34.6367 33.1792C34.3171 33.8064 33.8072 34.3164 33.18 34.6359C32.4669 34.9992 31.5335 34.9992 29.6667 34.9992H10.3333C8.46649 34.9992 7.53307 34.9992 6.82003 34.6359C6.19282 34.3164 5.68289 33.8064 5.36331 33.1792C5 32.4662 5 31.5328 5 29.6659V17.6077Z"
        stroke="#E1E1E4"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M10 20L30 20" stroke="#181D29" strokeWidth="2" strokeLinecap="round" />
      <path
        d="M7 25H9.5V27.8125H12.5V30.625H16V33"
        stroke="#181D29"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M29.7314 23.6445C30.3147 23.118 31.2419 23.118 31.8252 23.6445C32.4381 24.1978 32.4379 25.1185 31.8252 25.6719L30.9854 26.4297H38.3252C39.1077 26.4297 39.8319 27.0132 39.832 27.8379C39.832 28.6626 39.1078 29.2461 38.3252 29.2461H30.9854L31.8252 30.0039C32.4381 30.5572 32.438 31.4779 31.8252 32.0312C31.2419 32.5579 30.3148 32.5579 29.7314 32.0312L26.21 28.8516C25.597 28.2982 25.597 27.3775 26.21 26.8242L29.7314 23.6445Z"
        fill="#181D29"
        stroke="#FAFAFB"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_10480_32498">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const HeatingIcon = ({ width = 24, height = 24, ...props }: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.8538 21.6426C18.3028 22.3793 18.0601 23.3348 17.3117 23.7768C16.5634 24.2188 15.5927 23.9799 15.1436 23.2433C13.2631 20.1581 13.2631 16.9502 15.1436 13.8651C16.4236 11.7651 16.4236 9.78801 15.1436 7.68808C14.6946 6.95142 14.9373 5.99594 15.6857 5.55394C16.434 5.11195 17.4047 5.3508 17.8538 6.08747C19.7343 9.1726 19.7343 12.3805 17.8538 15.4657C16.5738 17.5656 16.5738 19.5427 17.8538 21.6426ZM9.95253 21.6426C10.4016 22.3793 10.1589 23.3348 9.4105 23.7768C8.66213 24.2188 7.69144 23.9799 7.24241 23.2433C5.3619 20.1581 5.3619 16.9502 7.24241 13.8651C8.5224 11.7651 8.5224 9.78801 7.24241 7.68808C6.79339 6.95142 7.03607 5.99594 7.78444 5.55394C8.53281 5.11195 9.5035 5.3508 9.95253 6.08747C11.833 9.1726 11.833 12.3805 9.95253 15.4657C8.67254 17.5656 8.67254 19.5427 9.95253 21.6426ZM25.755 21.6426C26.204 22.3793 25.9613 23.3348 25.213 23.7768C24.4646 24.2188 23.4939 23.9799 23.0449 23.2433C21.1644 20.1581 21.1644 16.9502 23.0449 13.8651C24.3249 11.7651 24.3249 9.78801 23.0449 7.68808C22.5958 6.95142 22.8385 5.99594 23.5869 5.55394C24.3353 5.11195 25.306 5.3508 25.755 6.08747C27.6355 9.1726 27.6355 12.3805 25.755 15.4657C24.475 17.5656 24.475 19.5427 25.755 21.6426Z"
      fill="#181D29"
    />
  </svg>
)

export const ShowerIcon = ({ width = 24, height = 24, ...props }: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_10493_32685)">
      <path
        d="M12.443 24.732C12.443 25.612 11.723 26.332 10.843 26.332C9.96297 26.332 9.24297 25.612 9.24297 24.732C9.24297 23.852 9.96297 23.132 10.843 23.132C11.723 23.132 12.443 23.852 12.443 24.732ZM17.243 23.132C16.363 23.132 15.643 23.852 15.643 24.732C15.643 25.612 16.363 26.332 17.243 26.332C18.123 26.332 18.843 25.612 18.843 24.732C18.843 23.852 18.123 23.132 17.243 23.132ZM23.643 23.132C22.763 23.132 22.043 23.852 22.043 24.732C22.043 25.612 22.763 26.332 23.643 26.332C24.523 26.332 25.243 25.612 25.243 24.732C25.243 23.852 24.523 23.132 23.643 23.132ZM28.443 16.732V19.932H6.04297V16.732C6.04297 11.084 10.219 6.44403 15.643 5.66003V2.33203H18.843V5.66003C24.267 6.44403 28.443 11.084 28.443 16.732ZM25.243 16.732C25.243 12.316 21.659 8.73203 17.243 8.73203C12.827 8.73203 9.24297 12.316 9.24297 16.732H25.243ZM10.843 27.932C9.96297 27.932 9.24297 28.652 9.24297 29.532C9.24297 30.412 9.96297 31.132 10.843 31.132C11.723 31.132 12.443 30.412 12.443 29.532C12.443 28.652 11.723 27.932 10.843 27.932ZM17.243 27.932C16.363 27.932 15.643 28.652 15.643 29.532C15.643 30.412 16.363 31.132 17.243 31.132C18.123 31.132 18.843 30.412 18.843 29.532C18.843 28.652 18.123 27.932 17.243 27.932ZM23.643 27.932C22.763 27.932 22.043 28.652 22.043 29.532C22.043 30.412 22.763 31.132 23.643 31.132C24.523 31.132 25.243 30.412 25.243 29.532C25.243 28.652 24.523 27.932 23.643 27.932Z"
        fill="#181D29"
      />
    </g>
    <defs>
      <clipPath id="clip0_10493_32685">
        <rect width="32" height="32" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
)

export const VentilationIcon = ({ width = 24, height = 24, ...props }: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.5234 25.456C19.14 28.0725 23.3823 28.0725 25.9989 25.456L21.261 20.7184L16.5234 15.9805C13.9069 18.5971 13.9069 22.8394 16.5234 25.456Z"
      stroke="#181D29"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5469 6.57529C13.9303 3.9587 9.68797 3.9587 7.07138 6.57529L11.8093 11.3128L16.5469 16.0508C19.1635 13.4342 19.1635 9.19187 16.5469 6.57529Z"
      stroke="#181D29"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.9716 16.0312C28.5882 13.4147 28.5882 9.17234 25.9716 6.55576L21.234 11.2937L16.4961 16.0312C19.1127 18.6478 23.355 18.6478 25.9716 16.0312Z"
      stroke="#181D29"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.09482 16.0078C4.47823 18.6244 4.47823 22.8667 7.09482 25.4833L11.8324 20.7454L16.5703 16.0078C13.9537 13.3912 9.7114 13.3912 7.09482 16.0078Z"
      stroke="#181D29"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
